export const getAudioContext = (): AudioContext => {
  if (window.AudioContext) {
    return new window.AudioContext();
  }

  // @ts-ignore
  return new window.webkitAudioContext();
};
